import styles from './GitHubPage.module.css';
import { GithubIcon, BookIcon, StarIcon, MapPinIcon, UsersIcon } from '../../icons';

const LANG_COLORS: Record<string, string> = {
  'TypeScript': '#3178c6',
  'Shell': '#89e051',
  'C#': '#178600',
  'Python': '#3572A5',
};

const PINNED_REPOS = [
  { name: 'my-website', desc: 'Welcome to my website', lang: 'TypeScript', stars: 4 },
  { name: 'dotfiles', desc: 'My config', lang: 'Shell', stars: 12 },
  { name: 'flappy-ball', desc: 'Remake of a once-popular mobile game', lang: 'C#', stars: 8 },
  { name: 'game-of-cycles', desc: 'Game of Cycles implemented for academic research', lang: 'Python', stars: 3 },
];

function ContributionGraph() {
  const weeks = 20;
  const days = 7;
  const levels = [0, 1, 2, 3, 4];

  // Deterministic pseudo-random pattern based on position
  const getLevel = (week: number, day: number) => {
    let h = (week * 7 + day + 1) | 0;
    h = Math.imul(h ^ (h >>> 16), 0x45d9f3b);
    h = Math.imul(h ^ (h >>> 13), 0x45d9f3b);
    h = (h ^ (h >>> 16)) >>> 0;
    const val = h % 100;
    if (val < 30) return 0;
    if (val < 55) return 1;
    if (val < 75) return 2;
    if (val < 90) return 3;
    return 4;
  };

  return (
    <div className={styles.contributionGraph}>
      <span className={styles.contributionLabel}>366 contributions in the last year</span>
      <div className={styles.graphGrid}>
        {Array.from({ length: weeks }, (_, w) => (
          <div key={w} className={styles.graphColumn}>
            {Array.from({ length: days }, (_, d) => (
              <div
                key={d}
                className={styles.graphCell}
                data-level={levels[getLevel(w, d)]}
              />
            ))}
          </div>
        ))}
      </div>
      <div className={styles.graphLegend}>
        <span>Less</span>
        {levels.map(l => (
          <div key={l} className={styles.graphCell} data-level={l} />
        ))}
        <span>More</span>
      </div>
    </div>
  );
}

export function GitHubPage() {
  return (
    <div className={styles.page}>
      <nav className={styles.nav}>
        <span className={styles.navLogo}><GithubIcon /></span>
        <span className={styles.navSearch}>Search or jump to...</span>
      </nav>
      <div className={styles.profileLayout}>
        <aside className={styles.sidebar}>
          <div className={styles.avatarWrap}>
            <img src="/profile.svg" alt="Profile" className={styles.avatar} />
          </div>
          <h1 className={styles.displayName}>Nick Bozentko</h1>
          <p className={styles.username}>nickbozentko</p>
          <p className={styles.bio}>Software Architect</p>
          <div className={styles.meta}>
            <span className={styles.metaItem}>
              <MapPinIcon />
              New York, NY
            </span>
            <span className={styles.metaItem}>
              <UsersIcon />
              <strong>24</strong> followers · <strong>18</strong> following
            </span>
          </div>
        </aside>
        <main className={styles.content}>
          <div className={styles.tabs}>
            <span className={styles.tab}>Overview</span>
            <span className={styles.tab}>Repositories</span>
            <span className={styles.tab}>Stars</span>
          </div>
          <h2 className={styles.sectionTitle}>Pinned</h2>
          <div className={styles.pinnedGrid}>
            {PINNED_REPOS.map(repo => (
              <div key={repo.name} className={styles.repoCard}>
                <div className={styles.repoName}>
                  <BookIcon />
                  <span>{repo.name}</span>
                </div>
                <p className={styles.repoDesc}>{repo.desc}</p>
                <div className={styles.repoMeta}>
                  <span className={styles.repoLang}>
                    <span className={styles.langDot} style={{ backgroundColor: LANG_COLORS[repo.lang] }} />
                    {repo.lang}
                  </span>
                  <span className={styles.repoStars}>
                    <StarIcon />
                    {repo.stars}
                  </span>
                </div>
              </div>
            ))}
          </div>
          <ContributionGraph />
        </main>
      </div>
    </div>
  );
}
